import { NetworkUserEvents } from "../analytics/events/networks";
import { track } from "../analytics/track";

// // // //

/**
 * trackPieChartToggleStablecoins
 * Tracks the event when a user toggles the "include stablecoins" button in the Network Pie Chart
 */
export function trackPieChartToggleStablecoins(props: {
    includeStablecoins: boolean;
}) {
    track(NetworkUserEvents.ClickNetworkPieChartToggleStablecoins, props);
}
